import { render } from "./AddNewSkillModal.vue?vue&type=template&id=b30d583e&ts=true"
import script from "./AddNewSkillModal.vue?vue&type=script&lang=ts"
export * from "./AddNewSkillModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__